import { Collapse } from 'bootstrap';

const navbar = document.querySelectorAll('.navbar');
const body = document.body;

const main_nav = document.getElementById('navbar');
const nav_items = main_nav.querySelectorAll('.scroll-to');

navbar.forEach(function (element) {
    element.addEventListener('hide.bs.collapse', function () {
        body.classList.remove('navbar-active');
    })
    element.addEventListener('show.bs.collapse', function () {
        setTimeout(() => {
            body.classList.add('navbar-active');
        }, 0)
    })
})

let hash, nav_id, nav_section;

nav_items.forEach(function (element) {
    element.addEventListener('click', function () {
    	// close toggle
    	const thisCollapsable = new Collapse(main_nav);
        thisCollapsable.hide();

        // scroll to
        hash = element.getAttribute('href');
        nav_id = hash.slice(1);// remove #
        navScrollTo(nav_id);

        event.preventDefault();
    })
});

// from subpage with hash link
if (window.location.hash) {
    hash = window.location.hash;
    nav_id = hash.slice(1);// remove #

    // timeout to calculate offset ...
    setTimeout(() => {
        navScrollTo(nav_id);
    }, 300);
    
    // remove hash
    history.pushState(null, null, ' ');
    //window.location.href.split('#')[0];
}

// scroll to functions
function navScrollTo(nav_id) {
    nav_section = document.getElementById(nav_id);
    if (nav_section) {          
      // scroll
      window.scrollTo({
        top: nav_section.offsetTop-80,
        behavior: "smooth",
      });
    }
}